import { useEffect } from 'react';
import { ArrowBack, Check } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useInvoiceQuery } from '../../../../api/gql';
import { BottomAppBar } from '../../../../components/BottomAppBar';
import { PageHeader } from '../../../../components/PageHeader';
import { useSafeNavigation } from '../../../../hooks/useSafeNavigation';
import { useConfirmInvoiceForm } from '../../../../modules/invoice/hooks/useConfirmInvoiceForm';
import { InvoiceFormModule } from '../../../../modules/invoice/InvoiceFormModule';
import { notify } from '../../../../utils/notification';

const TRANS_NS = 'page-check-invoice';

export const ConfirmInvoiceDrawerContent = () => {
  const { safeNavigate } = useSafeNavigation();
  const { invoiceId } = useParams();
  const { t } = useTranslation(TRANS_NS);

  const { data, error } = useInvoiceQuery({ id: invoiceId as string });

  useEffect(() => {
    if (error) {
      console.error(error);
      notify.negative({
        title: t('error.query.title'),
        message: t('error.query.text'),
      });
    }
  }, [error, t]);

  const {
    onFormSubmit,
    state: { isReady, isLoading },
  } = useConfirmInvoiceForm({
    onSuccess: () => safeNavigate(`..`),
    onError: () => {
      notify.negative({
        title: t('error.mutation.title'),
        message: t('error.mutation.text'),
      });
    },
    onValidationError: () => {
      notify.negative({
        title: t('error.validation.title'),
        message: t('error.validation.text'),
      });
    },
  });

  return (
    <>
      <Box py={2} px={4}>
        <PageHeader
          title={t('subtitle')}
          subtitle={t('invoiceNumber', {
            number: data?.invoice?.number ?? '...',
          })}
          backRouteTo={'..'}
          Icon={ArrowBack}
        />
        <Box mt={4} position={'relative'}>
          {invoiceId ? (
            <InvoiceFormModule
              sx={{
                p: 0,
                border: 0,
              }}
              invoiceId={invoiceId}
              invoiceFormProps={{
                onSubmit: (data) => onFormSubmit(invoiceId, data),
                defaultValidated: true,
                formId: 'invoice-form',
                allowInvoiceItems: false,
              }}
            />
          ) : null}
        </Box>
      </Box>
      <BottomAppBar stackProps={{ justifyContent: 'center' }}>
        <LoadingButton
          loading={isLoading}
          disabled={!isReady}
          type={'submit'}
          form={'invoice-form'}
          variant={'contained'}
          size={'large'}
          startIcon={<Check />}
        >
          {t('action.confirm')}
        </LoadingButton>
      </BottomAppBar>
    </>
  );
};
